<template>
  <div id="Illegal_building">
    <div class="font">
      <span class="introSubTitle"><b>城市违章建筑物遥感检测系统</b></span>
      <p class="textStyle">
        城市化进程与可持续发展亟需及时了解和掌控城市布局、环境变化、违章建筑、非法占地、地面绿化、湖泊分布以及道路更新等情况，及时准确地进行城市变化检测对于经济建设、环境监测和可持续发展具有重要意义。城市变化信息主要为人工建筑的变化信息，关注城市变化的重点包括局部区域内人工建筑的新建或拆除。通过影像密集匹配获取测区不同时相的三维地表模型，结合不同时相多角度影像、立体模型、匹配点云，利用面向对象分析方法获取初始变化候选区，并顾及建筑物本身的如三维高程、边缘、形状、空间关系等特征进行二三维综合的面向对象建筑物变化检测。
      </p>
    </div>
  <!-- <br/>   -->
    <img
        width="100%"
        src="@/assets/img/scientific/Illegal_building-0.jpg"
      />
      <img
        width="100%"
        src="@/assets/img/scientific/Illegal_building-01.jpg"
      />
<!--      <img-->
<!--        width="100%"-->
<!--        src="@/assets/img/scientific/Illegal_building-3.jpg"-->
<!--      />-->
    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {
      //       src: require("@/assets/static/Illegal_building.mp4"),
      //       type: "video/mp4",
      //     },
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#Illegal_building {
  margin-top: 20px;
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
